import {React,useState} from 'react';

export default function FirstNameLastName({onDataUpdate}) {
const[firstName,setFirstName]=useState("")
const[lastName,setLastName]=useState("")
    


  const handleChange=()=>{
    onDataUpdate(firstName && lastName ? `${firstName} ${lastName}`:"")
  }

    return (<>
  
        <div className="flex items-center justify-center px-6">
            <div className="wrapper rounded  mx-auto w-[900px]">
            <h1 className="text-[#1b1763] xl:text-5xl lg:text-4xl md:text-3xl text-2xl font-semibold text-center py-4">
            What’s your name?
                </h1>
            </div>
        </div>
        <div className="flex items-center justify-center sm:mb-6 mb-4 mt-2">
    <form>
      <div>
      <label for="firstname" className='font-normal text-gray-600 text-base'>First Name <span class="text-red-500">*</span></label><br></br>
      <input 
      className="md:text-2xl text-lg hover:border-[#F6BC29]  md:w-[500px] sm:w-[400px] w-[300px] my-2 md:py-4 py-2 px-6 rounded-2xl bg-white border-2 transition-all duration-300 overflow-hidden cursor-pointer outline-none focus:border-[#F6BC29] focus:shadow-[#F6BC29] focus:shadow-md"
     value={firstName}
     onChange={(e)=>{
        setFirstName(e.target.value);
        handleChange();
     }}
     />

      </div>
   <div className='sm:mt-6 mt-2'>
   <label for="lastname" className='font-normal text-gray-600 text-base'>Last Name <span class="text-red-500">*</span></label><br></br>
      <input 
      className="md:text-2xl text-lg hover:border-[#F6BC29]  md:w-[500px] sm:w-[400px] w-[300px] my-2 md:py-4 py-2 px-6 rounded-2xl bg-white border-2 transition-all duration-300 overflow-hidden cursor-pointer outline-none focus:border-[#F6BC29] focus:shadow-[#F6BC29] focus:shadow-md"
      value={lastName}
      onChange={(e)=>{
        setLastName(e.target.value);
        handleChange();
      }}
      />

   </div>

    </form>

   
        </div>

       
    </>
        
    );
}
